import { FileModel } from '@doltech/ui/lib/figma/DolEditor/elements/BlogEditor/model/file-upload-model';
import { types as t } from 'mobx-state-tree';

export const BlogVocabType = {
  SINGLE: 'SINGLE',
  LIST: 'LIST',
} as const;

export type BlogVocabType = typeof BlogVocabType[keyof typeof BlogVocabType];

const BlogVocabModel = t.model('BlogVocabModel', {
  id: t.maybeNull<any>(t.string),
  word: t.maybeNull<any>(t.string),
  pronoun: t.maybeNull<any>(t.string),
  type: t.maybe(FileModel),
  definition: t.maybeNull<any>(t.string),
  example: t.maybeNull<any>(t.string),
  imageUrl: t.maybeNull<any>(t.string),
});

export const BlogVocabList = t.model('BlogVocabList', {
  blogVocabs: t.optional(t.array(BlogVocabModel), []),
  blogVocabType: t.maybeNull<any>(t.string),
});
